import { z } from 'zod';
export const notificationConfigSchema = z.object({
    channels_enabled: z.array(z.enum(['email', 'sms', 'voice'])).default(['email']),
    quiet_hours_timezone: z.string().default('America/Chicago'),
    quiet_hours_start: z.string().regex(/^\d{2}:\d{2}$/).default('20:00'),
    quiet_hours_end: z.string().regex(/^\d{2}:\d{2}$/).default('08:00'),
    // Multiple recipients (new format)
    notification_emails: z.array(z.string().email()).optional(),
    notification_phones: z.array(z.string()).optional(),
    instant_connect_phones: z.array(z.string()).optional(),
    // Legacy single-recipient fields (backward compat)
    notification_email: z.string().email().optional(),
    notification_phone: z.string().optional(),
    instant_connect_phone: z.string().optional(),
});
//# sourceMappingURL=notification.js.map